"use client"

import { useState, useEffect } from "react"
import { Menu, X } from "lucide-react"

const MobileNav = () => {
  const [isOpen, setIsOpen] = useState(false)

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest(".mobile-nav") && !event.target.closest(".hamburger-menu")) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isOpen])

  // Prevent scrolling when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }

    return () => {
      document.body.style.overflow = "auto"
    }
  }, [isOpen])

  return (
    <>
      <button className="hamburger-menu" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      <div className={`mobile-nav ${isOpen ? "open" : ""}`}>
        <div className="mobile-nav-content">
          <a className={window.location.pathname === "/" ? "active" : ""} href="/">
            Home
          </a>
          <a className={window.location.pathname === "/events" ? "active" : ""} href="/events">
            Events
          </a>
          <a className={window.location.pathname === "/products" ? "active" : ""} href="/products">
            Products
          </a>
          <a href="/about">About Us</a>
          <a href="/contact">Contact</a>
        </div>
      </div>
    </>
  )
}

export default MobileNav
